import { type ReactNode, type FC } from 'react';
import EventCalendarContext, { type EventCalendarContextProps, type EventCalendarProps } from './EventCalendarContext';

interface EventCalendarProviderProps extends EventCalendarProps {
    children: ReactNode;
}

const EventCalendarProvider: FC<EventCalendarProviderProps> = ({
    children,
    ...restProps
}) => {
    const providerValue: EventCalendarContextProps = { ...restProps };

    return (
        <EventCalendarContext.Provider value={providerValue}>
            {children}
        </EventCalendarContext.Provider>
    );
};

export default EventCalendarProvider;
